export default __webpack_public_path__ + "static/media/parchment.0f6a1e85.png";